import React from 'react';
import { FormContext } from 'react-hook-form';

const EnhancedFormContext = (props) => {
  return <FormContext {...props} />;
};

export default EnhancedFormContext;
